import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from '../../constants/apiConstants'
import noImage from '../../images/no-image.jpg'
import { ToastContainer, toast } from "react-toastify";

function Index() {
    const [developers,setDevelopers] = useState([]);
    const [developerList, setDeveloperList] = useState([]);
    const [developerArray, setDeveloperArray] = useState([]);
    const [visibleLoadButton, setVisibleLoadButton] = useState(true);

    const getDeveloeprs = (e) => {
        axios.get(API_BASE_URL+'get/developers',{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setDevelopers(response.data.data.developers);
            setDeveloperArray(response.data.data.developers);
            setDeveloperList(response.data.data.allDevelopers);
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        })
    }

    const handleSearchClick = (e) => {
        const searchTerm = e.target.value;
        if(searchTerm.length > 2){
            const filteredItems = developerList.filter((item) => {
                    return (
                        item.user_name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
                    )
                }
            );
            setDevelopers(filteredItems);
            setVisibleLoadButton(false);
        }else{
            setDevelopers(developerArray);
            setVisibleLoadButton(true);
        }
    };

    useEffect(()=> {
        getDeveloeprs()
    },[]);

    return (
    <>
        <ToastContainer />
        <section class="grid_box">
            <div class="container">
                <div className="row align-items-center text_he_box">
                    <div className="col-md-4"><h4>Developers</h4></div>
                    <div className="col-md-4">  <div class="searchbox d-flex"><input class="form-control" placeholder="Search Developers" onChange={handleSearchClick} type="text"/><button type="button"><img alt="search-icon" src="/static/media/search-icon.f9aaf195dd5c680284dafd8006f643de.svg"/></button></div></div>
                    <div className="col-md-4"> <h4 className="property-title text-end">Verified Developers</h4></div>
                </div>
            </div>
        </section>

        <section class="developers_box">
            <div class="container">
                <div class="grid_dev">
                    <div class="row row-cols-3">
                    {developers.map((element) => (
                        <div class="custom-col-3 text-center">
                            {element.profile_picture ? (
                               <div className="new_box_img">
                               <img src={ASSETS_URL+"developer/profile/"+element.profile_picture} width="120px" height="auto" alt="" />
                               </div>
                            ) : (
                                <div className="new_box_img">
                                <img src={noImage} width="120px" height="auto" alt="" />
                                </div>
                            )}
                            <h5>{element.user_name}</h5>
                        </div>
                    ))}
                    </div>
                </div>
            </div>
        </section>

        {visibleLoadButton && (
        <div className="button_showmore button_showmore_developer text-center">
            <a href="#">Show More</a>
        </div>
        )}
    </>
    );
}

export default Index;